import * as React from 'react';
import styled from 'styled-components';

export type UILoaderProps = {
  message?: String
};
const LoadingContainer = styled.div`
  display: block;
  width: 100%;
  text-align: center;
  margin-top: 15px;
`;
const LoadingBar = styled.div`
  display: inline-block;
  width: 80px;
  height: 80px;
  position: relative;
  &:after {
    content: " ";
    display: block;
    position: absolute;
    top: 0;
    width: 74px;
    height: 74px;
    margin: 0px;
    border-radius: 50%;
    border: 6px solid #fff;
    border-color: #1a7a3f transparent #1a7a3f transparent;
    animation: lds-dual-ring 1.2s linear infinite;
  }
  @keyframes lds-dual-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
const LoadingMessage = styled.div`
  p {
    font-size: 18px;
    font-style: italic;
  }
`;
const AvoImg = styled.img`
  width: 66px;
  height: 66px;
  margin: 10px;
  animation: fade-loop 1.2s linear infinite;
  @keyframes fade-loop {
    0%, 100% {
      opacity: 1
    }
    50% {
      opacity: 0.6;
    }
  }
`;
export const UILoader = ({ message }: UILoaderProps) => (
  <LoadingContainer>
    <LoadingBar>
      <AvoImg src="https://assets.avochato.com/assets/favicon-256-c559d43ca09866bf7c0c7b91b1acaf829cf744c697b90bee18adc0edb440e46f.ico" />
    </LoadingBar>
    {message && (
      <LoadingMessage>
        <p>Loading your Conversations</p>
      </LoadingMessage>
    )}
  </LoadingContainer>
);
